import { TextAlign, VerticalAlign } from '@/types/text'
import { PlotbandLayoutMap, PlotbandLabelPosition } from './types'

export const HORIZONTAL_X: PlotbandLayoutMap = {
  [PlotbandLabelPosition.TopLeftOutside]: ({ startX, offsetX, offsetY }) => ({
    x: startX - offsetX,
    y: offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.TopLeftInside]: ({ startX, offsetX, offsetY }) => ({
    x: startX + offsetX,
    y: offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.TopOutside]: ({ startX, width, offsetY }) => ({
    x: startX + width / 2,
    y: offsetY,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.TopInside]: ({ startX, width, offsetY }) => ({
    x: startX + width / 2,
    y: offsetY,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.TopRightOutside]: ({ startX, width, offsetX, offsetY }) => ({
    x: startX + width + offsetX,
    y: offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.TopRightInside]: ({ startX, width, offsetX, offsetY }) => ({
    x: startX + width - offsetX,
    y: offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.RightOutside]: ({ startX, width, height, offsetX }) => ({
    x: startX + width + offsetX,
    y: height / 2,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.RightInside]: ({ startX, width, height, offsetX }) => ({
    x: startX + width - offsetX,
    y: height / 2,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.BottomRightOutside]: ({ startX, width, height, offsetX, offsetY }) => ({
    x: startX + width + offsetX,
    y: height - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.BottomRightInside]: ({ startX, width, height, offsetX, offsetY }) => ({
    x: startX + width - offsetX,
    y: height - offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.BottomOutside]: ({ startX, width, height, offsetY }) => ({
    x: startX + width / 2,
    y: height - offsetY,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.BottomInside]: ({ startX, width, height, offsetY }) => ({
    x: startX + width / 2,
    y: height - offsetY,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.BottomLeftOutside]: ({ startX, height, offsetX, offsetY }) => ({
    x: startX - offsetX,
    y: height - offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.BottomLeftInside]: ({ startX, height, offsetX, offsetY }) => ({
    x: startX + offsetX,
    y: height - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.LeftOutside]: ({ startX, height, offsetX }) => ({
    x: startX - offsetX,
    y: height / 2,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.LeftInside]: ({ startX, height, offsetX }) => ({
    x: startX + offsetX,
    y: height / 2,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Middle,
  }),
}

export const VERTICAL_X: PlotbandLayoutMap = {
  [PlotbandLabelPosition.TopLeftOutside]: ({ startX, offsetX, offsetY }) => ({
    x: startX - offsetX,
    y: offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.TopLeftInside]: ({ startX, offsetX, offsetY }) => ({
    x: startX + offsetX,
    y: offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.TopOutside]: ({ startX, width, offsetY }) => ({
    x: startX + width / 2,
    y: offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.TopInside]: ({ startX, width, offsetY }) => ({
    x: startX + width / 2,
    y: offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.TopRightOutside]: ({ startX, width, offsetX, offsetY }) => ({
    x: startX + width + offsetX,
    y: offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.TopRightInside]: ({ startX, width, offsetX, offsetY }) => ({
    x: startX + width - offsetX,
    y: offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.RightOutside]: ({ startX, width, height, offsetX }) => ({
    x: startX + width + offsetX,
    y: height / 2,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.RightInside]: ({ startX, width, height, offsetX }) => ({
    x: startX + width - offsetX,
    y: height / 2,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.BottomRightOutside]: ({ startX, width, height, offsetX, offsetY }) => ({
    x: startX + width + offsetX,
    y: height - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.BottomRightInside]: ({ startX, width, height, offsetX, offsetY }) => ({
    x: startX + width - offsetX,
    y: height - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.BottomOutside]: ({ startX, width, height, offsetY }) => ({
    x: startX + width / 2,
    y: height - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.BottomInside]: ({ startX, width, height, offsetY }) => ({
    x: startX + width / 2,
    y: height - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.BottomLeftOutside]: ({ startX, height, offsetX, offsetY }) => ({
    x: startX - offsetX,
    y: height - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.BottomLeftInside]: ({ startX, height, offsetX, offsetY }) => ({
    x: startX + offsetX,
    y: height - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.LeftOutside]: ({ startX, height, offsetX }) => ({
    x: startX - offsetX,
    y: height / 2,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.LeftInside]: ({ startX, height, offsetX }) => ({
    x: startX + offsetX,
    y: height / 2,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Top,
  }),
}

export const HORIZONTAL_Y: PlotbandLayoutMap = {
  [PlotbandLabelPosition.TopLeftOutside]: ({ startY, offsetX, offsetY }) => ({
    x: offsetX,
    y: startY - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.TopLeftInside]: ({ startY, offsetX, offsetY }) => ({
    x: offsetX,
    y: startY + offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.TopOutside]: ({ startX, width, startY, offsetY }) => ({
    x: startX + width / 2,
    y: startY - offsetY,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.TopInside]: ({ startX, width, startY, offsetY }) => ({
    x: startX + width / 2,
    y: startY + offsetY,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.TopRightOutside]: ({ startY, width, offsetX, offsetY }) => ({
    x: width - offsetX,
    y: startY - offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.TopRightInside]: ({ startY, width, offsetX, offsetY }) => ({
    x: width - offsetX,
    y: startY + offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.RightOutside]: ({ startY, height, width, offsetX }) => ({
    x: width - offsetX,
    y: startY + height / 2,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.RightInside]: ({ startY, height, width, offsetX }) => ({
    x: width - offsetX,
    y: startY + height / 2,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.BottomRightOutside]: ({ startY, height, width, offsetX, offsetY }) => ({
    x: width - offsetX,
    y: startY + height + offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.BottomRightInside]: ({ startY, height, width, offsetX, offsetY }) => ({
    x: width - offsetX,
    y: startY + height - offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.BottomOutside]: ({ startX, width, startY, height, offsetY }) => ({
    x: startX + width / 2,
    y: startY + height + offsetY,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.BottomInside]: ({ startX, width, startY, height, offsetY }) => ({
    x: startX + width / 2,
    y: startY + height - offsetY,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.BottomLeftOutside]: ({ startY, height, offsetX, offsetY }) => ({
    x: offsetX,
    y: startY + height + offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.BottomLeftInside]: ({ startY, height, offsetX, offsetY }) => ({
    x: offsetX,
    y: startY + height - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.LeftOutside]: ({ startY, height, offsetX }) => ({
    x: offsetX,
    y: startY + height / 2,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.LeftInside]: ({ startY, height, offsetX }) => ({
    x: offsetX,
    y: startY + height / 2,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Middle,
  }),
}

export const VERTICAL_Y: PlotbandLayoutMap = {
  [PlotbandLabelPosition.TopLeftOutside]: ({ startY, offsetX, offsetY }) => ({
    x: offsetX,
    y: startY - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.TopLeftInside]: ({ startY, offsetX, offsetY }) => ({
    x: offsetX,
    y: startY + offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.TopOutside]: ({ startX, width, startY, offsetY }) => ({
    x: startX + width / 2,
    y: startY - offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.TopInside]: ({ startX, width, startY, offsetY }) => ({
    x: startX + width / 2,
    y: startY + offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.TopRightOutside]: ({ startY, width, offsetX, offsetY }) => ({
    x: width - offsetX,
    y: startY - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.TopRightInside]: ({ startY, width, offsetX, offsetY }) => ({
    x: width - offsetX,
    y: startY + offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.RightOutside]: ({ startY, height, width, offsetX }) => ({
    x: width - offsetX,
    y: startY + height / 2,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.RightInside]: ({ startY, height, width, offsetX }) => ({
    x: width - offsetX,
    y: startY + height / 2,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.BottomRightOutside]: ({ startY, height, width, offsetX, offsetY }) => ({
    x: width - offsetX,
    y: startY + height + offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.BottomRightInside]: ({ startY, height, width, offsetX, offsetY }) => ({
    x: width - offsetX,
    y: startY + height - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Bottom,
  }),
  [PlotbandLabelPosition.BottomOutside]: ({ startX, width, startY, height, offsetY }) => ({
    x: startX + width / 2,
    y: startY + height + offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.BottomInside]: ({ startX, width, startY, height, offsetY }) => ({
    x: startX + width / 2,
    y: startY + height - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Middle,
  }),
  [PlotbandLabelPosition.BottomLeftOutside]: ({ startY, height, offsetX, offsetY }) => ({
    x: offsetX,
    y: startY + height + offsetY,
    textAlign: TextAlign.Right,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.BottomLeftInside]: ({ startY, height, offsetX, offsetY }) => ({
    x: offsetX,
    y: startY + height - offsetY,
    textAlign: TextAlign.Left,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.LeftOutside]: ({ startY, height, offsetX }) => ({
    x: offsetX,
    y: startY + height / 2,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Top,
  }),
  [PlotbandLabelPosition.LeftInside]: ({ startY, height, offsetX }) => ({
    x: offsetX,
    y: startY + height / 2,
    textAlign: TextAlign.Center,
    verticalAlign: VerticalAlign.Top,
  }),
}
